import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { ResultContext } from '../../contexts/ResultContext';
import { useTheme } from '../../contexts/ThemeContext';

const ContributingFieldsBarChart = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';

    const { result } = useContext(ResultContext);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = result?.results?.visualization_data_jsons['5_contributing_fields'];
        if (!url) return;

        const fetchData = async () => {
            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch file');
                const json = await response.json();
                setData(json);
            } catch (error) {
                console.error('Error loading bar chart data:', error);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [result]);

    if (loading || !Array.isArray(data)) {
        return <div>Loading chart...</div>;
    }

    const option = {
        title: {
            text: 'Top Contributing Fields by Frequency',
            left: 'center',
            textStyle: { color: axisColor },

        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: ({ 0: { name, value } }) => `${name}: ${value}`,
        },
        grid: {
            left: '2%',
            right: '5%',
            bottom: '5%',
            top: '15%',
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                color: axisColor,
                formatter: '{value}',
            },
        },
        yAxis: {
            type: 'category',
            data: data.map(item => item.Field),
            inverse: true,
            axisLabel: {
                color: axisColor,
            }
        },
        series: [
            {
                name: 'Frequency',
                type: 'bar',
                data: data.map(item => item.Frequency),
                itemStyle: {
                    color: '#10b981', // teal-500
                },
                label: {
                    show: true,
                    position: 'right',
                    textStyle: { color: axisColor },
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 shadow mt-10">
            <ReactECharts option={option} style={{ height: 500 }} />
        </div>
    );
};

export default ContributingFieldsBarChart;
